export const Permissions = {
  dashboard: "partner.dashboard.view",
  transactions: "partner.transactions.view",
  transactionsExport: "partner.transactions.export",
  issuedUsers: "partner.issued-users.view",
  payouts: "partner.payouts.view",
  subMerchantsView: "partner.sub-merchants.view",
  subMerchantsCreate: "partner.sub-merchants.create",
  subMerchantsUpdate: "partner.sub-merchants.update",
  subMerchantsDelete: "partner.sub-merchants.delete",
  subMerchantDashboard: "partner.sub-merchant-dashboard.view",
  subMerchantTransactions: "partner.sub-merchant-transactions.view",
  subMerchantTransactionsExport: "partner.sub-merchant-transactions.export",
  subMerchantLedger: "partner.sub-merchant-ledger.view",
  subMerchantBankAccountView: "partner.sub-merchant-bank-account.view",
  subMerchantBankAccountUpdate: "partner.sub-merchant-bank-account.update",
  subMerchantWithdrawals: "partner.sub-merchant-withdrawals.view",
  enterpriseDashboard: "partner.enterprise-dashboard.view",
  enterpriseTransactions: "partner.enterprise-transactions.view",
  enterpriseTransactionsExport: "partner.enterprise-transactions.export",
  enterpriseLedger: "partner.enterprise-ledger.view",
  enterprisePayouts: "partner.enterprise-payouts.view",
  enterprisePayoutsCreate: "partner.enterprise-payouts.create",
  enterpriseBankAccount: "partner.enterprise-bank-account.view",
  enterpriseMerchants: "partner.enterprise-merchants.view",
  webhookLogs: "partner.webhook-logs.view",
  settingsAny: "partner.settings.*",
  teamView: "partner.settings.team.view",
  teamCreate: "partner.settings.team.create",
  teamUpdate: "partner.settings.team.update",
  passwordUpdate: "partner.settings.password.update",
  webhookUpdate: "partner.settings.webhook.update",
  credentialsUpdate: "partner.settings.credentials.update",
  ipWhitelistView: "partner.settings.ip-whitelist.view",
  ipWhitelistCreate: "partner.settings.ip-whitelist.create",
  ipWhitelistDelete: "partner.settings.ip-whitelist.delete",
};

export const DASHBOARD_METRIC_KEYS = [
  "total_gross_volume",
  "total_net_volume",
  "total_discount",
  "total_txn_count",
  "total_failed_count",
  "pans_issued_count",
  "total_declined_count",
  "total_timeout_count",
  "total_cancelled_count",
  "issuing_gross_volume",
  "issuing_net_volume",
  "issuing_discount",
  "issuing_txn_count",
  "issuing_failed_count",
  "issuing_declined_count",
  "acquiring_gross_volume",
  "acquiring_net_volume",
  "acquiring_discount",
  "acquiring_txn_count",
  "acquiring_failed_count",
  "acquiring_declined_count",
  "acquiring_timeout_count",
  "acquiring_cancelled_count",
];

export const roleLabel = (roleName) => {
  if (!roleName) return "No role";
  return roleName
    .replace(/^partner\./, "")
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
